export default (theme) => ({
	subtitle: {
	  fontSize: '1.125rem',
	  fontWeight: 'normal',
	  margin: theme.spacing(0, 0, 2.5),
	  color: '#0C0030',
	}
});
